import { render, staticRenderFns } from "./DocumentContent.vue?vue&type=template&id=b79dd936&scoped=true&lang=pug"
import script from "./DocumentContent.vue?vue&type=script&lang=js"
export * from "./DocumentContent.vue?vue&type=script&lang=js"
import style0 from "./DocumentContent.vue?vue&type=style&index=0&id=b79dd936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79dd936",
  null
  
)

export default component.exports